import { PAGES_TO_INCLUDE_FOR_CHECKOUT_COM } from '@constants/checkoutCom';

import { useRouter } from 'next/router';

const useIsCheckoutComEnabled = (): boolean => {
  const router = useRouter();

  const isCheckoutComEnabled = PAGES_TO_INCLUDE_FOR_CHECKOUT_COM.includes(
    router.pathname,
  );

  return isCheckoutComEnabled;
};

export default useIsCheckoutComEnabled;
